export default function VolumeAssigned({ 
    version = '4.0',
    exercise,
    set,
    isSkipped,
    isCompleted,
    showLabel = true
}) {

    var setUnitsAssigned = 0
    if (exercise.setUnit === 'reps') setUnitsAssigned = set?.reps
    if (exercise.setUnit === 'seconds') setUnitsAssigned = set?.seconds
    if (version === '5.0'){ 
        setUnitsAssigned = set?.setUnitsAssigned
    }

    if (isSkipped === true || isCompleted === true) {
        return null
    }

    return (
        <div className='space-y-2'>
            {showLabel && (
                <div className='text-xs text-center text-gray-600'>
                    {exercise.setUnit === 'reps' && <>Target Reps</>}
                    {exercise.setUnit === 'seconds' && <>Target Hold</>}
                </div>
            )}

            <div className='w-20 h-20 rounded-xl flex items-center justify-center border border-gray-400 bg-white relative'>
                <p className="text-4xl text-center text-gray-900 mb-3">
                    {setUnitsAssigned}
                </p>

                <div className='absolute bottom-2 left-0 w-full text-center text-xs text-gray-800'>
                    {exercise.setUnit === 'reps' &&
                        <>
                            {exercise.lateral === 'unilateral' && <>per side</>}
                            {exercise.lateral === 'bilateral' && <>total</>}
                        </>
                    }
                    {exercise.setUnit === 'seconds' && 
                        <>
                            {exercise.lateral === 'unilateral' && <>sec / side</>}
                            {exercise.lateral === 'bilateral' && <>seconds</>}
                        </>
                    }
                </div>
            </div>
        </div>
    )
}